import type {TInitiativeLogType} from '../types/initiativeActivityTypes'
import {INITIATIVE} from '../Translation/English/initiative'

export const ACTIVITY_PAGE_SIZE = 30

export const ACTIVITY_QUERY_KEY_ROOT = 'initiativeActivity'

/** Remounting the panel within this window reuses the cache instead of refetching. */
export const ACTIVITY_STALE_TIME_MS = 30_000

/** Starts the next page 200px before the sentinel scrolls into view. */
export const ACTIVITY_PREFETCH_MARGIN = '0px 0px 200px 0px'

/** One human tag per log type, as a translation key. */
export const ACTIVITY_TAG_KEYS: Record<TInitiativeLogType, string> = {
  CREATE_INITIATIVE: INITIATIVE.tagCreated,
  CREATE_TASK: INITIATIVE.tagCreated,
  UPDATE_INITIATIVE: INITIATIVE.tagUpdated,
  EDIT_TASK: INITIATIVE.tagUpdated,
  UPDATE_INITIATIVE_STATUS: INITIATIVE.tagStatus,
  UPDATE_TASK_STATUS: INITIATIVE.tagStatus,
  BLOCK_TASK: INITIATIVE.tagBlocked,
  UNBLOCK_TASK: INITIATIVE.tagUnblocked,
  DELETE_TASK: INITIATIVE.tagDeleted,
  CREATE_TASK_COMMENT: INITIATIVE.tagComment,
  DELETE_TASK_COMMENT: INITIATIVE.tagCommentDeleted,
}
